/**
 * Coups de pouce — Attendu 684 « Résoudre des problèmes de proportionnalité (procédures) ».
 * Une entrée par generator_key (cf. gen_684.js).
 */

// ── Retour à l'unité : diviser puis multiplier (id cp684play1) ──
// Exemple hors pool (cahiers — le générateur ne sert que des fruits au kg) :
// rien de recopiable. Les trois lignes du raisonnement s'enchaînent, avec les
// flèches ÷ 3 puis × 5 des deux côtés. Remise à zéro au clic.
const SVG_RETOUR_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 172" role="img"
     aria-label="3 cahiers coûtent 6 euros. Une flèche divisé par 3 mène à 1 cahier coûte 2 euros, puis une flèche fois 5 mène à 5 cahiers coûtent 10 euros">
  <g id="cp684play1" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <text x="8" y="20" font-size="13" font-weight="600" fill="#64748b" font-family="system-ui,sans-serif">3 cahiers coûtent 6 €. Et 5 cahiers ?</text>
  <!-- ligne 1 -->
  <g opacity="0">
    <text x="110" y="68" font-size="14" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">3 cahiers</text>
    <text x="250" y="68" font-size="14" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">6 €</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play1.click+0.3s" fill="freeze"/>
  </g>
  <!-- ligne 2 + flèches ÷ 3 -->
  <g opacity="0">
    <text x="110" y="104" font-size="14" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">1 cahier</text>
    <text x="250" y="104" font-size="14" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">2 €</text>
    <path d="M102 72 Q78 86 102 100" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
    <path d="M102 100 L94 96 M102 100 L96 105" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
    <text x="62" y="90" font-size="12" font-weight="700" fill="#1E3A8A" text-anchor="middle" font-family="system-ui,sans-serif">÷ 3</text>
    <path d="M290 72 Q314 86 290 100" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
    <path d="M290 100 L298 96 M290 100 L296 105" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
    <text x="330" y="90" font-size="12" font-weight="700" fill="#1E3A8A" text-anchor="middle" font-family="system-ui,sans-serif">÷ 3</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play1.click+1.2s" fill="freeze"/>
  </g>
  <!-- ligne 3 + flèches × 5 -->
  <g opacity="0">
    <text x="110" y="140" font-size="14" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">5 cahiers</text>
    <path d="M102 108 Q78 122 102 136" fill="none" stroke="#1D9E75" stroke-width="1.5"/>
    <path d="M102 136 L94 132 M102 136 L96 141" fill="none" stroke="#1D9E75" stroke-width="1.5"/>
    <text x="62" y="126" font-size="12" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">× 5</text>
    <path d="M290 108 Q314 122 290 136" fill="none" stroke="#1D9E75" stroke-width="1.5"/>
    <path d="M290 136 L298 132 M290 136 L296 141" fill="none" stroke="#1D9E75" stroke-width="1.5"/>
    <text x="330" y="126" font-size="12" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">× 5</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play1.click+2.6s" fill="freeze"/>
  </g>
  <text x="250" y="140" font-size="14" font-weight="700" fill="#94a3b8" font-family="system-ui,sans-serif" opacity="0">?<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play1.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play1.click+2.6s" fill="freeze"/><animate attributeName="opacity" values="1;0" dur="0.25s" begin="cp684play1.click+3.8s" fill="freeze"/></text>
  <text x="250" y="140" font-size="14" font-weight="700" fill="#1D9E75" font-family="system-ui,sans-serif" opacity="0">10 €<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play1.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play1.click+3.9s" fill="freeze"/></text>
  <!-- conclusion -->
  <g opacity="0">
    <rect x="20" y="156" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="164" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">On trouve le prix de 1 cahier, puis on multiplie.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play1.click+4.7s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_RETOUR = {
    pages: [
        {
            titre: 'La méthode',
            lignes: [
                'Trouve d\'abord le prix d\'**une seule unité** (en divisant), puis **multiplie** par la quantité demandée.',
            ],
            svg: SVG_RETOUR_ANIM,
        },
    ],
};

// ── Linéarité multiplicative : comparer les deux quantités (id cp684play2) ──
// Exemple hors pool (bouteilles) : rien de recopiable. Deux lignes, la
// quantité demandée est un multiple visible — les flèches × 4 des deux côtés.
const SVG_LINMULT_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 140" role="img"
     aria-label="2 bouteilles coûtent 3 euros. 8 bouteilles, c'est 4 fois plus : une flèche fois 4 relie 2 bouteilles à 8 bouteilles, une autre relie 3 euros au point d'interrogation, qui devient 12 euros">
  <g id="cp684play2" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <text x="8" y="20" font-size="13" font-weight="600" fill="#64748b" font-family="system-ui,sans-serif">2 bouteilles coûtent 3 €. Et 8 bouteilles ?</text>
  <!-- les deux lignes -->
  <g opacity="0">
    <text x="100" y="62" font-size="14" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">2 bouteilles</text>
    <text x="255" y="62" font-size="14" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">3 €</text>
    <text x="100" y="106" font-size="14" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">8 bouteilles</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play2.click+0.3s" fill="freeze"/>
  </g>
  <text x="255" y="106" font-size="14" font-weight="700" fill="#94a3b8" font-family="system-ui,sans-serif" opacity="0">?<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play2.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play2.click+0.3s" fill="freeze"/><animate attributeName="opacity" values="1;0" dur="0.25s" begin="cp684play2.click+2.7s" fill="freeze"/></text>
  <text x="255" y="106" font-size="14" font-weight="700" fill="#1D9E75" font-family="system-ui,sans-serif" opacity="0">12 €<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play2.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play2.click+2.8s" fill="freeze"/></text>
  <!-- flèches × 4 -->
  <g opacity="0">
    <path d="M92 66 Q66 84 92 102" fill="none" stroke="#1D9E75" stroke-width="1.5"/>
    <path d="M92 102 L84 98 M92 102 L86 107" fill="none" stroke="#1D9E75" stroke-width="1.5"/>
    <text x="52" y="88" font-size="12" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">× 4</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play2.click+1.3s" fill="freeze"/>
  </g>
  <g opacity="0">
    <path d="M293 66 Q319 84 293 102" fill="none" stroke="#1D9E75" stroke-width="1.5"/>
    <path d="M293 102 L301 98 M293 102 L299 107" fill="none" stroke="#1D9E75" stroke-width="1.5"/>
    <text x="333" y="88" font-size="12" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">× 4</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play2.click+2s" fill="freeze"/>
  </g>
  <!-- conclusion -->
  <g opacity="0">
    <rect x="20" y="124" width="8" height="8" rx="2" fill="#1D9E75"/>
    <text x="36" y="132" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">8 bouteilles, c'est 4 × 2 : le prix est aussi multiplié par 4.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play2.click+3.6s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_LINMULT = {
    pages: [
        {
            titre: 'La méthode',
            lignes: [
                'Compare les deux quantités : si la nouvelle est **un multiple** de la première, le prix est **multiplié par le même nombre**.',
            ],
            svg: SVG_LINMULT_ANIM,
        },
    ],
};

// ── Linéarité additive : additionner les deux couples (id cp684play3) ──
// Exemple hors pool (stylos) : rien de recopiable. Les deux couples donnés,
// l'accolade qui les réunit, puis l'addition des prix.
const SVG_LINADD_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 156" role="img"
     aria-label="2 stylos coûtent 5 euros et 3 stylos coûtent 7,50 euros. Une accolade réunit 2 plus 3 égale 5 stylos, et l'addition 5 plus 7,50 égale 12,50 euros donne le prix de 5 stylos">
  <g id="cp684play3" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <text x="8" y="20" font-size="13" font-weight="600" fill="#64748b" font-family="system-ui,sans-serif">Combien coûtent 5 stylos ?</text>
  <!-- les deux couples -->
  <g opacity="0">
    <text x="70" y="56" font-size="14" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">2 stylos</text>
    <text x="230" y="56" font-size="14" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">5 €</text>
    <text x="70" y="84" font-size="14" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">3 stylos</text>
    <text x="230" y="84" font-size="14" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">7,50 €</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play3.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play3.click+0.3s" fill="freeze"/>
  </g>
  <!-- accolade côté quantités : 2 + 3 = 5 -->
  <g opacity="0">
    <path d="M56 46 Q42 46 42 56 Q42 70 36 70 Q42 70 42 84 Q42 94 56 94" fill="none" stroke="#1D9E75" stroke-width="1.5"/>
    <text x="24" y="74" font-size="12" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">5</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play3.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play3.click+1.4s" fill="freeze"/>
  </g>
  <!-- ligne résultat -->
  <g opacity="0">
    <text x="70" y="120" font-size="14" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">5 stylos</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play3.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play3.click+2.4s" fill="freeze"/>
  </g>
  <text x="230" y="120" font-size="14" font-weight="700" fill="#94a3b8" font-family="system-ui,sans-serif" opacity="0">?<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play3.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play3.click+2.4s" fill="freeze"/><animate attributeName="opacity" values="1;0" dur="0.25s" begin="cp684play3.click+3.4s" fill="freeze"/></text>
  <text x="170" y="120" font-size="14" font-weight="700" fill="#1D9E75" font-family="system-ui,sans-serif" opacity="0">5 + 7,50 = 12,50 €<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play3.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play3.click+3.5s" fill="freeze"/></text>
  <!-- conclusion -->
  <g opacity="0">
    <rect x="20" y="140" width="8" height="8" rx="2" fill="#1D9E75"/>
    <text x="36" y="148" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">5 stylos, c'est 2 + 3 : on additionne les deux prix.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play3.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play3.click+4.3s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_LINADD = {
    pages: [
        {
            titre: 'La méthode',
            lignes: [
                'Si la quantité demandée est la **somme** des deux quantités données, le prix est la **somme des deux prix**.',
            ],
            svg: SVG_LINADD_ANIM,
        },
    ],
};

// ── Procédure : l'arbre de décision animé (id cp684play4) ──
// Les trois gestes apparaissent l'un après l'autre : je repère la situation
// (à gauche), je choisis le geste (à droite, coloré). Valeurs neutres (2 kg,
// 8 kg…) qui ne résolvent aucun tirage. Remise à zéro au clic.
const SVG_PROCEDURE_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 150" role="img"
     aria-label="Trois situations. 8 kg c'est 4 fois 2 kg : je multiplie par 4. 5 kg c'est 2 kg plus 3 kg : j'additionne les deux prix. 7 kg, ni multiple ni somme : je divise pour trouver 1 kg, puis je multiplie">
  <g id="cp684play4" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <text x="8" y="20" font-size="13" font-weight="600" fill="#64748b" font-family="system-ui,sans-serif">Quel est le bon geste ?</text>
  <!-- geste 1 : le multiple -->
  <g opacity="0">
    <text x="20" y="60" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">8 kg, c'est 4 × 2 kg</text>
    <text x="190" y="60" font-size="13" font-weight="700" fill="#1D9E75" font-family="system-ui,sans-serif">→ je multiplie par 4</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play4.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play4.click+0.3s" fill="freeze"/>
  </g>
  <!-- geste 2 : la somme -->
  <g opacity="0">
    <text x="20" y="94" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">5 kg, c'est 2 kg + 3 kg</text>
    <text x="190" y="94" font-size="13" font-weight="700" fill="#1E3A8A" font-family="system-ui,sans-serif">→ j'additionne les prix</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play4.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play4.click+2.3s" fill="freeze"/>
  </g>
  <!-- geste 3 : le retour à l'unité -->
  <g opacity="0">
    <text x="20" y="128" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">7 kg : ni multiple, ni somme</text>
    <text x="190" y="128" font-size="13" font-weight="700" fill="#B45309" font-family="system-ui,sans-serif">→ je divise, puis je multiplie</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp684play4.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp684play4.click+4.3s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_PROCEDURE = {
    pages: [
        {
            titre: 'La méthode',
            svg: SVG_PROCEDURE_ANIM,
        },
    ],
};

const CP_684 = {
    retour_unite_saisie: CP_RETOUR,
    linearite_mult_saisie: CP_LINMULT,
    linearite_add_saisie: CP_LINADD,
    // Partage (décision utilisateur 2026-08-11) : la variante objets est un
    // retour à l'unité, les autres des coefficients directs.
    coefficient_saisie: CP_RETOUR,
    procedure_qcm: CP_PROCEDURE,
    // Partage (décision utilisateur 2026-08-11) : la quantité par personne
    // est un retour à l'unité.
    recette_saisie: CP_RETOUR,
};

export default CP_684;
